__turbopack_context__.v({
  "fact": "AppointmentReview-module-scss-module__BqmIIW__fact",
  "memberTags": "AppointmentReview-module-scss-module__BqmIIW__memberTags",
  "review": "AppointmentReview-module-scss-module__BqmIIW__review",
  "servicesSection": "AppointmentReview-module-scss-module__BqmIIW__servicesSection",
});
